import { Language } from "../const";

export type SeminarArticle = {
  id: string;
  title: string;
  date: string;
  topic: string;
  thumb: string;
  img: string;
  content: React.ReactNode;
  year?: number;
};

export const seminarLanguageMap: Record<Language, string> = {
  [Language.EN]: "/data/en/seminars-en.json",
  [Language.TC]: "/data/tc/seminars-tc.json",
  [Language.SC]: "/data/sc/seminars-sc.json",
};

export const getSeminarData = (
  jsonData: SeminarArticle[],
  json_en: SeminarArticle[]
): SeminarArticle[] => {
  return jsonData.map((item, index) => {
    const { date, topic, ...rest } = item;
    return {
      ...rest,
      year: new Date(date).getFullYear(),
      date,
      topic: json_en?.[index].topic,
    };
  });
};
